
import { defineComponent } from 'vue';
import {clientServices} from '../clientServices.service';
import {TransactionalInterface} from "@/interfaces/Transactional.interface";
import dayjs from 'dayjs';
const clientService = new clientServices();

export default defineComponent({
    name: 'PaymentHistory',
    data() {
        return {
            transactionsHistory: [] as TransactionalInterface[],
            params: { page: 0, size: 6, total: 0 },
        };
    },
    methods:{
        paginate(event: {page:number, rows:number}): void {
            this.getPaymentHistory(event.page, event.rows)
        },

        async getPaymentHistory(page: number, size: number){
            await clientService.getTransactions({page, size}).then((response: any) => {
                this.transactionsHistory = response.content;
                this.params.total = response.total;
            });
        },

        transactionsPaginate(): void{
            let page = this.params.page;
            let size = this.params.size;
            this.getPaymentHistory(page, size);
        },

        formatCurrency(value: number) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        formatDate(date: string){
            return dayjs(date).format('DD/MM/YYYY');
        },

        acessPaymentDetails(referenceCheckout: string){
            window.open(`https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${referenceCheckout}`, '_blank');
        },

        paymentStatusCodes(status: string){
                switch (status) {
                    case 'CANCELED':
                        return navigator.language == 'pt-BR' ? 'Cancelado' : 'Canceled';
                    case 'PAID':
                        return navigator.language == 'pt-BR' ? 'Pago' : 'Paid';
                    case 'PENDING':
                        return navigator.language == 'pt-BR' ? 'Pendente' : 'Pending';
                    case 'REFUNDED':
                        return navigator.language == 'pt-BR' ? 'Estornado' : 'Refunded';
                    case 'REJECTED':
                        return navigator.language == 'pt-BR' ? 'Recusado' : 'Rejected';
                    default:
                        break;
                }
            },
    },
    mounted(){
        this.transactionsPaginate();
    }
});
